import { render, staticRenderFns } from "./ShortcutContact.vue?vue&type=template&id=77ccd0e8"
import script from "./ShortcutContact.vue?vue&type=script&lang=js"
export * from "./ShortcutContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports